if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        const opener = this.openedBy;
        super.hide();

        // ModalDialog.hide() calls window.pauseAllMedia(), which also pauses the
        // background video that was autoplaying in the gallery before the modal opened.
        if (opener) {
          const openerVideo = opener.querySelector('video[autoplay]');
          if (openerVideo) openerVideo.play();
        }
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        // Mobile : la modale est un slider horizontal (scroll-snap en CSS), on se place sur le média cliqué.
        if (getComputedStyle(container).scrollSnapType !== 'none') {
          container.scrollLeft +=
            activeMedia.getBoundingClientRect().left - container.getBoundingClientRect().left;
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();

        // ModalDialog.show() calls window.pauseAllMedia() after opening, which pauses
        // this video if it was already autoplaying before the modal opened.
        const activeVideo = activeMedia.querySelector('video[autoplay]');
        if (activeVideo) activeVideo.play();
      }
    }
  );
}
